import React from 'react';
import { formatDate } from '../../utils/syncStatusHelpers';

function CurrentCustomerInformationDetails({ customer, startedBy, instanceId, startDate, endDate }) {
  if (!customer) {
    return null;
  }

  const isGlobalSyncs = customer.TenantInt === 9999999 || customer.CustomerID === 9999999;
  const title = isGlobalSyncs ? 'All Tenants Syncs Information - these syncs impact all customers' : 'Customer Information';

  const tableData = [
    { label: 'Customer ID', value: customer.CustomerID },
    { label: 'Tenant Int', value: customer.TenantInt },
    { label: 'Tenant Name', value: customer.TenantName || 'N/A' },
    { label: 'Company Name', value: customer.CompanyName || 'N/A' },
    ...(instanceId ? [{ label: 'Instance ID', value: instanceId }] : []),
    ...(startedBy ? [{ label: 'Started By', value: startedBy }] : []),
    ...(startDate ? [{ label: 'Start Date', value: formatDate(startDate) }] : []),
    ...(endDate ? [{ label: 'End Date', value: formatDate(endDate) }] : [])
  ];

  return (
    <div style={{
      marginBottom: '15px', 
      paddingTop: '5px',
      paddingBottom: '10px'
    }}>
      <div style={{ 
        fontSize: '16px', 
        fontWeight: '600', 
        marginBottom: '12px'
      }}>
        {title}
      </div>
      <div style={{ 
        border: '1px solid #e1dfdd', 
        borderRadius: '4px',
        overflow: 'hidden'
      }}>
        <table className="customer-info-table" style={{ 
          width: '100%', 
          borderCollapse: 'collapse',
          fontSize: '14px'
        }}>
          <thead>
            <tr style={{ 
              borderBottom: '2px solid #e1dfdd',
              backgroundColor: '#f3f2f1'
            }}>
              {tableData.map((item, index) => (
                <th key={index} style={{ 
                  padding: '8px 12px', 
                  fontWeight: '600',
                  borderRight: index < tableData.length - 1 ? '1px solid #e1dfdd' : 'none'
                }}>
                  {item.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {tableData.map((item, index) => (
                <td key={index} style={{ 
                  padding: '8px 12px', 
                  borderRight: index < tableData.length - 1 ? '1px solid #e1dfdd' : 'none',
                  backgroundColor: 'white'
                }}>
                  {item.value}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default CurrentCustomerInformationDetails;
